// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import PropTypes from 'prop-types';
import QRCode from 'react-qr-code';

export default function QRCodeDialog(props) {

  const open = props.open || false
  const qrValue = props.qrValue || ""
  // console.log('QRCodeDialog ~ qrValue', qrValue);
  const onClose = props.onClose

  const handleCloseClick = () => {
    onClose && onClose();
  }


  return (
    <Dialog
      open={open}
      onClose={handleCloseClick}
      // fullWidth={true}
      maxWidth={"sm"}
      aria-describedby="qrcode-dialog-description"
    >
      <DialogContent>
        <DialogContentText id="qrcode-dialog-description">
          <QRCode
            value={qrValue}
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseClick}>Close</Button>
      </DialogActions>
    </Dialog>

  );
}

QRCodeDialog.propTypes = {
  open: PropTypes.bool,
  qrValue: PropTypes.string,
  onClose: PropTypes.func,
};
